"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));

var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));

var _endOfMonth = _interopRequireDefault(require("date-fns/endOfMonth"));

var _keycode = _interopRequireDefault(require("keycode"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _emotion = require("emotion");

var _datePickerPopover = _interopRequireDefault(require("../date-picker/date-picker-popover"));

var _datePickerPresets = _interopRequireDefault(require("../date-picker/date-picker-presets"));

var _dateInputField = _interopRequireDefault(require("../date-input-field"));

var _dateRangeInputCalendar = _interopRequireDefault(require("../_date-range-input-calendar"));

var _dateString = require("./../_utils/date-string");

var _dateLocales = _interopRequireDefault(require("./../_utils/date-locales"));

var _supportTextWrapper = _interopRequireDefault(require("../_support-text-wrapper"));

var _getSupportTextAriaDescribedby = _interopRequireDefault(require("./../_utils/get-support-text-aria-describedby"));

var _functional = require("./../_utils/functional");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widthStyles = (0, _functional.memoizeByKeys)(function (_ref) {
  var width = _ref.width;
  return (0, _emotion.css)({
    width: width,
    // If an explicit width is set then don't allow the textarea to flex
    flex: width ? "none !important" : undefined
  });
}, ["width"]);
/* eslint-disable react/prop-types */

/**
 * A form control for selecting date ranges.
 */

var DateRangePickerClass = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DateRangePickerClass, _React$Component);

  var _super = _createSuper(DateRangePickerClass);

  function DateRangePickerClass() {
    var _this;

    (0, _classCallCheck2["default"])(this, DateRangePickerClass);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCalendarViewDate", function () {
      return _this.props.defaultViewDate || (0, _dateString.parseDateString)(_this.props.value[0]) && _this.props.value[0] || (0, _dateString.parseDateString)(_this.props.value[1]) && _this.props.value[1] || _this.props.now;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      calendarViewDate: _this.getCalendarViewDate(),
      input: "start"
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeField", function (input) {
      return function (inputValue) {
        var _this$props = _this.props,
            value = _this$props.value,
            allowSameStartAndEnd = _this$props.allowSameStartAndEnd,
            onChange = _this$props.onChange;
        onChange( // The fields should use the exact same logic that the calendar does when
        // it comes to changing dates
        _dateRangeInputCalendar["default"].getNextValue({
          value: value,
          input: input,
          inputValue: inputValue,
          allowSameStartAndEnd: allowSameStartAndEnd
        })); // Update the view to ensure that the new date is visible

        _this.onChangeCalendarViewDate(inputValue);
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeCalendarViewDate", function (date) {
      var calendarViewDate = _this.state.calendarViewDate;
      var parsedCalendarViewDate = (0, _parseISO["default"])(calendarViewDate);
      var firstDate = (0, _dateString.toDateString)((0, _startOfMonth["default"])(parsedCalendarViewDate));
      var lastDate = (0, _dateString.toDateString)((0, _endOfMonth["default"])(parsedCalendarViewDate));

      if (date && !(0, _dateString.isWithinRange)(date, firstDate, lastDate)) {
        _this.setState({
          calendarViewDate: date
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeOpenPopover", function () {
      return _this.onChangeCalendarViewDate(_this.getCalendarViewDate());
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownEndDateField", function (event) {
      // If the user hits tab on the end date field (to navigate via keyboard to
      // the calendar input) then move the input selection (not the focus, but the
      // input that will be filled when a date is selected via the calendar) back
      // to the start date. This allows keyboard-only users to follow the normal
      // selection flow (start date first, then end date) after tabbing through
      // the input fields to get to the calendar input.
      if ((0, _keycode["default"])(event) === "tab") {
        _this.setState({
          input: "start"
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderField", function (_ref2) {
      var id = _ref2.id,
          supportTextId = _ref2.supportTextId,
          input = _ref2.input,
          clearButton = _ref2.clearButton,
          clearButtonLabel = _ref2.clearButtonLabel,
          onClear = _ref2.onClear,
          error = _ref2.error,
          popoverIsOpen = _ref2.popoverIsOpen,
          _onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur;
      var props = _this.props;
      var ariaDescribedbyValue = props.helperText || props.constraintText || props.errorMessage ? (0, _getSupportTextAriaDescribedby["default"])({
        id: supportTextId,
        hasHelperText: !!props.helperText,
        hasConstraintText: !!props.constraintText,
        hasErrorMessage: !!props.errorMessage,
        errorMessageFirst: props.size === "xlarge"
      }) : undefined;
      var value = props.value[input === "start" ? 0 : 1];
      return /*#__PURE__*/_react["default"].createElement(_dateInputField["default"], {
        key: input,
        value: value,
        onChange: _this.onChangeField(input),
        focus: popoverIsOpen && _this.state.input === input ? true : undefined,
        disabled: props.disabled,
        disabledDates: props.disabledDates,
        label: _this.props[input === "start" ? "startLabel" : "endLabel"],
        placeholder: _this.props[input === "start" ? "startPlaceholder" : "endPlaceholder"],
        size: props.size,
        onKeyDown: input === "end" ? _this.onKeyDownEndDateField : undefined,
        onFocus: function onFocus(event) {
          _this.setState({
            input: input
          }); // When an input field is focused and the popover is open, shift the
          // calendar view to include the selected value for that input (start
          // or end date).


          if (popoverIsOpen) {
            _this.onChangeCalendarViewDate(value);
          }

          _onFocus(event);
        },
        onBlur: onBlur,
        invalidInputMessage: props.invalidInputMessage,
        error: error,
        locale: props.locale,
        autoFocus: (props.autoFocus || props.inaccessibleAutoFocus) && input === "start",
        autoFill: false,
        clearButton: clearButton,
        clearButtonLabel: clearButtonLabel,
        onClear: onClear,
        id: id,
        "aria-describedby": ariaDescribedbyValue
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(DateRangePickerClass, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var _this$state = this.state,
          calendarViewDate = _this$state.calendarViewDate,
          input = _this$state.input;
      var popoverId = props.popoverId ? props.popoverId : (0, _uniqueId["default"])("daterangepicker-popover-");
      var dateRangePickerId = (0, _uniqueId["default"])("daterangepicker-");
      return /*#__PURE__*/_react["default"].createElement(_supportTextWrapper["default"], {
        id: dateRangePickerId,
        helperText: props.helperText,
        constraintText: props.constraintText,
        errorMessage: props.errorMessage,
        helperBelowFormField: props.size === "xlarge",
        className: widthStyles({
          width: props.width
        })
      }, /*#__PURE__*/_react["default"].createElement(_datePickerPopover["default"], {
        valueFilled: Boolean(props.value[0] && props.value[1]),
        width: props.width,
        disabled: props.disabled,
        anchor: function anchor(anchorProps) {
          return [_this2.renderField(_objectSpread({
            id: props.startId,
            supportTextId: dateRangePickerId,
            input: "start",
            error: props.startError,
            clearButton: props.clearButton,
            clearButtonLabel: props.startClearButtonLabel,
            onClear: props.onStartClear
          }, anchorProps)), _this2.renderField(_objectSpread({
            id: props.endId,
            supportTextId: dateRangePickerId,
            input: "end",
            error: props.endError,
            clearButton: props.clearButton,
            clearButtonLabel: props.endClearButtonLabel,
            onClear: props.onEndClear
          }, anchorProps))];
        },
        onBeforeOpen: this.onBeforeOpenPopover,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        id: popoverId
      }, function (_ref3) {
        var t = _ref3.t,
            popoverIsOpen = _ref3.popoverIsOpen,
            closePopover = _ref3.closePopover;
        return [/*#__PURE__*/_react["default"].createElement(_dateRangeInputCalendar["default"], {
          key: "calendar",
          locale: props.locale,
          disabledDates: props.disabledDates,
          value: props.value,
          onChange: function onChange(value) {
            // Close the popover if we have a complete date range and an end
            // date was just selected
            if (input === "end" && value[0] && value[1]) {
              closePopover();
            } else {
              // Otherwise move the calendar input to the next date
              _this2.setState({
                input: !value[0] ? "start" : "end"
              });
            } // Notify the user of the change


            props.onChange(value);
          },
          viewDate: calendarViewDate,
          onChangeViewDate: _this2.onChangeCalendarViewDate,
          now: props.now,
          monthsInView: props.monthsInView,
          monthWidth: props.monthWidth,
          previousMonthLabel: props.previousMonthLabel,
          nextMonthLabel: props.nextMonthLabel,
          input: input,
          renderDate: props.renderDate,
          renderDay: props.renderDay,
          dateLabel: props.dateLabel,
          animateMonthChange: popoverIsOpen,
          allowSameStartAndEnd: props.allowSameStartAndEnd
        }), props.presets.length > 0 ? /*#__PURE__*/_react["default"].createElement(_datePickerPresets["default"], {
          key: "presets",
          t: t,
          presets: props.presets,
          label: props.presetsLabel,
          onChange: function onChange(value) {
            props.onChange(value);
            closePopover();
          },
          disabledDates: props.disabledDates
        }) : null];
      }), " ");
    }
  }]);
  return DateRangePickerClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */
// Keep refs from being passed. We're doing this for 4.x - the
// most recent breaking change - so that we can change the
// _actual_ component to functional later without waiting
// for the next breaking change


var DateRangePicker = function DateRangePicker(props) {
  return /*#__PURE__*/_react["default"].createElement(DateRangePickerClass, props);
};

DateRangePicker.displayName = "DateRangePicker";
DateRangePicker.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Called any time the user enters a full, valid, enabled date into the date
   * picker. Updated dates will be provided to the function as an array of
   * date strings in the format YYYY-MM-DD.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * If set to true the user will be able to choose the same date for the start
   * and the end of the date range.
   *
   * This can be helpful if a single date or a date range is acceptable, or if
   * the date range picker is used in conjunction with time pickers (not yet
   * part of Meridian, [+1 the backlog SIM](https://sim.amazon.com/issues/MRDN-438))
   * to allow the selection of a time range that may fall within a single day or
   * span multiple days.
   */
  allowSameStartAndEnd: _propTypes["default"].bool,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * Appends a button to both the start and end inputs that the user can click to
   * clear the input. This will trigger the `onChange` callback with a value of `""`.
   *
   * @since  5.x
   */
  clearButton: _propTypes["default"].bool,

  /**
   * Add constraint text to provide critical information regarding date range picker content.
   *
   * @since 5.22.0
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * A function that can be used to construct a screen-reader label for a particular
   * day. The function will be passed an object with the following properties.
   *
   * `date`: `string` of date in the format YYYY-MM-DD
   *
   * `label`: `string` of the localized day of the month (e.g. "Thursday, Nov 22, 2018")
   *
   * `current`: `boolean` set to `true` if the date is today's date
   *
   * `selected`: `boolean` set to `true` if date is selected
   *
   * `disabled`: `boolean` set to `true` if date is disabled
   *
   * `range`: `boolean` set to `true` if date is in the range of selected dates
   *
   * @since 5.20.0
   */
  dateLabel: _propTypes["default"].func,

  /**
   * This date is used to determine which month the calendar should display
   * by default. The date must be provided in the format YYYY-MM-DD. If not
   * provided then the calendar will display the month of `value`, or
   * `now` if no value is provided.
   */
  defaultViewDate: _propTypes["default"].string,

  /**
   * This disables interaction with the entire date picker. If you want to
   * disable the selection of specific dates then use the `disabledDates` prop.
   */
  disabled: _propTypes["default"].bool,

  /**
   * A function that can be used to disable specific dates. The function will
   * be passed date strings in the format YYYY-MM-DD and is expected to return
   * true for disabled dates and false otherwise.
   */
  disabledDates: _propTypes["default"].func,

  /**
   * An accessible label for the end clear button. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * @since  5.x
   */
  endClearButtonLabel: _propTypes["default"].string,

  /**
   * Used to set the input on the ending range into a more general error state, such as when it
   * cannot be blank.
   *
   * Consider pairing this state with an `errorMessage` prop explaining what the error is.
   */
  endError: _propTypes["default"].bool,

  /**
   * Sets an `id` attribute on the ending range's input field..
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.18.0
   */
  endId: _propTypes["default"].string,

  /**
   * The label for the end date input field.
   */
  endLabel: _propTypes["default"].string,

  /**
   * The placeholder for the start date input field.
   */
  endPlaceholder: _propTypes["default"].string,

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the DateRangePicker.
   *
   * @since 5.22.0
   */
  errorMessage: _propTypes["default"].string,

  /**
   * Add helper text to provide additional instruction.
   *
   * @since 5.22.0
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * If set to true then the input will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * A function that returns an error message for invalid or disabled dates.
   * The function must return a localized string. The string will be displayed
   * to the user to help guide them.
   *
   * Two arguments will be passed to the function. The first argument will be an error code - either
   * "INVALID_DATE" if the user's date doesn't exist (e.g. 2018-40-40) or
   * "DISABLED_DATE" if the user's date has been disabled via the
   * `disabledDates` prop. The second argument will be the date entered by the
   * user in the format YYYY-MM-DD. This argument will only be provided for
   * the "DISABLED_DATE" error code (the "INVALID_DATE" code means we couldn't
   * actually construct a date).
   */
  invalidInputMessage: _propTypes["default"].func,

  /**
   * The locale to use when rendering the input (e.g. month names, names of
   * days of the week, etc.). See the [Intl API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl).
   */
  locale: _propTypes["default"].oneOf(Object.keys(_dateLocales["default"])),

  /**
   * Set the width of a single month.
   */
  monthWidth: _propTypes["default"].number,

  /**
   * The number of calendar months to display at a time.
   */
  monthsInView: _propTypes["default"].number,

  /**
   * A localized label for the next month button.
   */
  nextMonthLabel: _propTypes["default"].string,

  /**
   * Define today's date (in the format YYYY-MM-DD). This date will be
   * marked in the calendar with a special indicator.
   */
  now: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the popover container.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.18.0
   */
  popoverId: _propTypes["default"].string,

  /**
   * A list of presets to allow quick selection of common date ranges.
   *
   * If provided, these presets will be shown as buttons in the date picker's
   * calendar popover.
   */
  presets: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].arrayOf(_propTypes["default"].string)
  })),

  /**
   * A localized label to be shown above the list of presets.
   */
  presetsLabel: _propTypes["default"].string,

  /**
   * A localized label for the previous month button.
   */
  previousMonthLabel: _propTypes["default"].string,

  /**
   * A function that can be used to customize the rendering of a single day. The
   * function is passed an object which contains the following props.
   *
   * `date`: `string` of date in the format YYYY-MM-DD
   *
   * `label`: `string` of the localized day of the month (e.g. "21")
   *
   * `current`: `boolean` set to `true` if the date is todays date
   *
   * `selected`: `boolean` set to `true` if date is selected
   *
   * `disabled`: `boolean` set to `true` if date is disabled
   *
   * `range`: `boolean` set to `true` if date is in the range of selected dates
   *
   * @since 5.20.0
   */
  renderDate: _propTypes["default"].func,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `renderDate` instead.
   *
   * @deprecated 5.20.0
   */
  renderDay: _propTypes["default"].func,

  /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */
  size: _propTypes["default"].oneOf(["medium", "large", "xlarge"]),

  /**
   * An accessible label for the start clear button. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * @since  5.x
   */
  startClearButtonLabel: _propTypes["default"].string,

  /**
   * Used to set the input on the starting range into a more general error state, such as when it
   * cannot be blank.
   *
   * Consider pairing this state with an `errorMessage` prop explaining what the error is.
   */
  startError: _propTypes["default"].bool,

  /**
   * Sets an `id` attribute on the starting range's input field.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.18.0
   */
  startId: _propTypes["default"].string,

  /**
   * The label for the start date input field.
   */
  startLabel: _propTypes["default"].string,

  /**
   * The placeholder for the start date input field.
   */
  startPlaceholder: _propTypes["default"].string,

  /**
   * The currently selected dates as an array of date strings in the format
   * YYYY-MM-DD.
   *
   * Update this when `onChange` is called to ensure the component is interactive
   * (see the documentation for the `onChange` prop).
   */
  value: _propTypes["default"].arrayOf(_propTypes["default"].string),

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   *
   * @since 5.x
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the entire component (inputs + popover calendars) loses focus.
   * The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event) is passed as the first argument to the function.
   *
   * @since 5.x
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the end clear button is clicked (be sure to set
   * `endClearButton` to `true`). No arguments are passed to this callback.
   *
   * @since 5.x
   */
  onEndClear: _propTypes["default"].func,

  /**
   * This is called when the entire component (inputs + popover calendars) gains focus.
   * The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event) is passed as the first argument to the function.
   *
   * @since 5.x
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the start clear button is clicked (be sure to set
   * `startClearButton` to `true`). No arguments are passed to this callback.
   *
   * @since 5.x
   */
  onStartClear: _propTypes["default"].func
} : {};
DateRangePicker.defaultProps = {
  locale: "en-US",
  disabledDates: _noop["default"],
  now: (0, _dateString.toDateString)(new Date()),
  presets: [],
  value: [],
  size: "medium",
  invalidInputMessage: function invalidInputMessage(code) {
    return {
      INVALID_DATE: "This value is not a valid date.",
      DISABLED_DATE: "This date is not available."
    }[code];
  }
};
var _default = DateRangePicker;
exports["default"] = _default;